<template>
  <div class="order-details-receipt">
    <v-card class="pa-2" tile color="yellow lighten-5">
      <v-row>
        <v-col cols="10">
          <span class="font-weight-bold">Item</span>
        </v-col>
        <v-col cols="2" align="end">
          <span class="font-weight-bold">{{order.currency}}</span>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <template v-for="(item, i) in order.items">
        <v-row :key="'item' + i">
          <v-col cols="10" class="py-1">
            <span class="font-weight-bold">{{item.quantity}} x {{item.label}}</span>
          </v-col>
          <v-col cols="2" class="py-1" align="end">
            <span class="font-weight-bold">{{item.price}}</span>
          </v-col>
        </v-row>
        <template v-for="(modifier, j) in item.modifiers">
          <v-row :key="'item' + i + 'modifier' + j">
            <v-col cols="10" class="py-1">
              <span class="pl-4">{{modifier.quantity}} x {{modifier.label}}</span>
            </v-col>
            <v-col cols="2" class="py-1" align="end">
              <span>{{modifier.price}}</span>
            </v-col>
          </v-row>
          <template v-for="(submodifier, k) in modifier.submodifiers">
            <v-row :key="'item' + i + 'modifier' + j +'submodifier' + k">
              <v-col cols="10" class="py-1">
                <span class="pl-4">{{submodifier.quantity}} x {{submodifier.label}}</span>
              </v-col>
              <v-col cols="2" class="py-1" align="end">
                <span>{{submodifier.price}}</span>
              </v-col>
            </v-row>
          </template>
        </template>
      </template>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="10">
          <span class="font-weight-bold">Total</span>
        </v-col>
        <v-col cols="2" align="end">
          <span class="font-weight-bold">{{order.price}}</span>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  props: { order: { type: Object } },
};
</script>
